import React from "react";

const BabyCountModal = ({ show, onSelect, onClose }) => {
  if (!show) return null;
  return (
    <div className="modal show custom-modall" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0">
            
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body  text-center">
            <p>
              Congratulations! We're here to support you through every stage of pregnancy and beyond.
            </p>
            <h5 style={{fontSize:"1.5rem"}}>Are you expecting:</h5>
            <div className="d-flex flex-column gap-2 mt-4">
              <button className="win-model-btn-primary" onClick={() => onSelect(1)}>One baby</button>
              <button className="win-model-btn-primary" onClick={() => onSelect(2)}>Two babies</button>
              <button className="win-model-btn-primary" onClick={() => onSelect(3)}>Three or more</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BabyCountModal;
